<template>
    <tbody>
        <CostableTableRow
            class="hover:bg-initial larger-font bolder-font"
            :is-heading-row="true"
            heading-class="text-right"
        >
            <template v-slot:heading>
                Subtotal:
            </template>
            <template v-slot:totalCost>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Cost"
                >
                    {{ formatCurrency(totals.cost) }}
                </span>
            </template>
            <template v-slot:totalPrice>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Price"
                >
                    {{ formatCurrency(totals.price) }}
                </span>
            </template>
            <template v-slot:markup>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Markup"
                >
                    {{ formatCurrency(totals.markup) }}
                </span>
            </template>
            <template v-slot:margin>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Margin"
                >
                    {{ formatPercentage(totals.margin) }}
                </span>
            </template>
            <template v-slot:commissionDue>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Commission Due"
                >
                    {{ formatCurrency(totals.commission_due) }}
                </span>
            </template>
            <template v-slot:totalProfit>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Total Profit"
                >
                    {{ formatCurrency(totals.profit) }}
                </span>
            </template>
        </CostableTableRow>
    </tbody>
</template>

<script>
import { formatCurrency, formatPercentage } from '@/utils/helpers';
import CostableTableRow from '@/modules/costable/_components/CostableTableRow';

export default {
    components: { CostableTableRow },
    computed: {
        totals() {
            return this.$store.getters['costable/subtotals'];
        },
    },

    methods: {
        formatCurrency,
        formatPercentage,
    },

};
</script>

<style lang="scss" scoped>
.larger-font {
    font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}
</style>
